import { CheckIcon } from "@chakra-ui/icons";
import {
  Accordion,
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text
} from "@chakra-ui/react";
import { useColorModeValue } from "@chakra-ui/system";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContatoType } from "models/contato_type";
import { EntregavelItem } from "models/entregavel_itens_type";
import { ModeloItemOrcamento } from "models/modelo_item_orcamento";
import { ModeloNegocioType } from "models/modelo_negocio_type";
import { NotaRodape } from "models/nota_rodape_type";
import { OrderCategory } from "models/order_category";
import { OrderItemProduct } from "models/order_item_product";
import { OrderType } from "models/order_type";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import { FaRegFileExcel } from "react-icons/fa";
import { MdMail, MdPrint, MdSave } from "react-icons/md";
import formatNumber from "../hooks/formatNumber";
import OrderCalc from "./OrderCalc";
import OrderData from "./OrderData";
import OrderItemDynamic from "./OrderItemDynamic";
import OrderLetter from "./OrderLetter";

interface IFormOrder {
  showModal: (show: boolean) => void;
  show: boolean;
  accountSelected: OrderType | undefined;
  loading: boolean;
  save: () => void;
  error: boolean;
  nomeRef: any;
  selectedClient: PessoaType | undefined;
  selectedAgency: PessoaType | undefined;
  selectedFilial: PessoaType | undefined;
  onChangeClient: (client: string) => void;
  clients: PessoaType[] | undefined;
  agency: PessoaType[] | undefined;
  filteredClients: PessoaType[] | undefined;
  filteredAgency: PessoaType[] | undefined;
  onChangeAgency: (ag: string) => void;
  onChangeFilial: (filial: string) => void;
  calculaTotalOrder: (valor: number) => void;
  total: number;
  totalItens: number;
  itens: OrderCategory[] | undefined;
  showCategory: boolean;
  saveItem: () => void;
  changeItem: (item: OrderCategory) => void;
  removeItem: (item: OrderCategory) => void;
  showItemModal: (show: boolean) => void;
  borderColor: string;
  showCadastraraMidia: (show: boolean) => void;
  showCadastrarEntregavel: (show: boolean) => void;
  changeInput: (tipo: string, value: string) => void;
  usuario: UsuarioModel;
  filiais: PessoaType[] | undefined;
  showAgenciaInputModal: (show: boolean) => void;
  showAgenciaInput: boolean;
  condicaoPagamento: CondicaoPagamento[] | undefined;
  modeloNegocio: ModeloNegocioType[] | undefined;
  onChangeModeloNegocio: (modelo: string) => void;
  onChangePagamento: (pagamento: string) => void;
  selectedCondicaoPagamento: CondicaoPagamento | undefined;
  selectedModeloNegocio: ModeloNegocioType | undefined;
  entregavel: ClientClassificationType[] | undefined;
  midias: ClientClassificationType[] | undefined;
  onChangeEntregavel: (et: any) => void;
  onChangeMidias: (midia: any) => void;
  selectedEntregaveis: EntregavelItem[] | undefined;
  selectedMidias: ClientClassificationType[] | undefined;
  data: Date;
  validade: Date;
  reorder: (
    list: OrderCategory[],
    startIndex: number,
    endIndex: number
  ) => void;
  drag: boolean;
  isDragable: (drag: boolean) => void;
  contatoAgencia: string;
  emailAgencia: string;
  telefoneAgencia: string;
  listContatoAgencia: ContatoType[];
  contatoCliente: string;
  emailCliente: string;
  telefoneCliente: string;
  listContatoCliente: ContatoType[];

  carta: string;
  changeCarta: (carta: string) => void;
  nome: string;
  descricao: string;
  exportExcel: () => void;
  changeFootNotes: (notes: string) => void;
  footNotes: NotaRodape[] | undefined;
  selectedFootNote: NotaRodape | undefined;
  desconto: number;
  acrescimo: number;
  comissao: number;
  totalCalculado: number;
  tipoAcrescimo: string;
  tipoComissao: string;
  tipoDesconto: string;
  onChangeTemplate: (item: string) => void;
  templateList: ModeloItemOrcamento[];
  changeCadastroDescricao: (notes: string) => void;
  descricoes: NotaRodape[] | undefined;
  selectedCadastro: NotaRodape | undefined;
  showContatoModal: (show: boolean, type: string) => void
  showContactModal: boolean
  editContact: (type: string) => void
  saveContact: (type: string, action: string) => void;
  selectedContact: ContatoType | undefined;
  changeType: (type: string) => void
  type: string;
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  showAprovacaoModal: (show: boolean) => void;
  addRowItem: (item: OrderItemProduct, categ: OrderCategory) => void;
  editRow: (item: OrderItemProduct, categ: OrderCategory) => void;
  deleteRow: (item: OrderItemProduct, categ: OrderCategory) => void;
  itemList: OrderItemProduct[];

}

const FormOrder = ({
  showModal,
  show,
  accountSelected,
  error,
  selectedClient,
  selectedAgency,
  onChangeClient,
  loading,
  agency,
  clients,
  save,
  calculaTotalOrder,
  total,
  totalItens,
  onChangeAgency,
  changeItem,
  itens,
  nomeRef,
  removeItem,
  saveItem,
  showCategory,
  showItemModal,
  borderColor,
  changeInput,
  usuario,
  filiais,
  onChangeFilial,
  selectedFilial,
  showAgenciaInputModal,
  showAgenciaInput,
  condicaoPagamento,
  modeloNegocio,
  onChangeModeloNegocio,
  onChangePagamento,
  selectedCondicaoPagamento,
  selectedModeloNegocio,
  entregavel,
  midias,
  onChangeEntregavel,
  onChangeMidias,
  selectedEntregaveis,
  selectedMidias,
  data,
  validade,
  showCadastraraMidia,
  showCadastrarEntregavel,
  reorder,
  drag,
  isDragable,
  contatoAgencia,
  emailAgencia,
  telefoneAgencia,
  listContatoAgencia,
  contatoCliente,
  emailCliente,
  telefoneCliente,
  listContatoCliente,
  carta,
  changeCarta,
  nome,
  descricao,
  exportExcel,
  filteredClients,
  filteredAgency,
  changeFootNotes,
  footNotes,
  selectedFootNote,
  desconto,
  acrescimo,
  comissao,
  totalCalculado,
  tipoAcrescimo,
  tipoComissao,
  tipoDesconto,
  onChangeTemplate,
  templateList,
  changeCadastroDescricao,
  descricoes,
  selectedCadastro,
  showContatoModal,
  showContactModal,
  editContact,
  saveContact,
  selectedContact,
  changeType,
  type,
  showFormPessoa,
  editPessoa,
  showAprovacaoModal,
  addRowItem,
  deleteRow,
  editRow,
  itemList
}: IFormOrder) => {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  return (
    <Box>
      <Box>
        <Box>
          <Text
            fontWeight={"black"}
            color={"red.600"}
            fontSize={20}
            mb={4}
            mr={4}
            alignSelf={"flex-end"}
            float={"right"}
          >
            {selectedModeloNegocio === null
              ? `Total dos itens: ${formatNumber(total)} `
              : `Total dos itens: ${formatNumber(totalCalculado)}`}
          </Text>
          <Box px="0px" mb="16px" mt="0px" justifyContent="space-between" ml={4}>
            <Stack direction="row" spacing={4}>
              <Button
                leftIcon={<MdMail />}
                colorScheme="brand"
                size={'sm'}
                variant="solid"
              >
                Enviar
              </Button>
              <Button
                leftIcon={<MdPrint />}
                colorScheme="brand"
                size={'sm'}
                variant="solid"
              >
                Imprimir
              </Button>
              <Button
                leftIcon={<MdSave />}
                colorScheme="brand"
                size={'sm'}
                variant="solid"
                isLoading={loading}
                onClick={() => save()}
              >
                Salvar
              </Button>
              <Button
                leftIcon={<FaRegFileExcel />}
                colorScheme="brand"
                variant="solid"
                size={'sm'}
                onClick={() => exportExcel()}
              >
                Excel
              </Button>

              <Button
                leftIcon={<CheckIcon />}
                colorScheme="brand"
                size={'sm'}
                variant="solid"
                onClick={() => { showAprovacaoModal(true) }}
              >
                Aprovar
              </Button>
            </Stack>
          </Box>

        </Box>
        <Accordion defaultIndex={[0, 1, 2, 3]} allowMultiple mt={12}>
          <OrderData
            accountSelected={accountSelected}
            brandStars={brandStars}
            error={error}
            textColor={textColor}
            onChangeClient={onChangeClient}
            agency={agency}
            calculaTotalOrder={calculaTotalOrder}
            clients={clients}
            onChangeAgency={onChangeAgency}
            showCadastrarEntregavel={showCadastrarEntregavel}
            selectedClient={selectedClient}
            selectedAgency={selectedAgency}
            changeInput={changeInput}
            usuario={usuario}
            filiais={filiais}
            onChangeFilial={onChangeFilial}
            selectedFilial={selectedFilial}
            showAgenciaInput={showAgenciaInput}
            showAgenciaInputModal={showAgenciaInputModal}
            condicaoPagamento={condicaoPagamento}
            modeloNegocio={modeloNegocio}
            onChangeModeloNegocio={onChangeModeloNegocio}
            onChangePagamento={onChangePagamento}
            selectedCondicaoPagamento={selectedCondicaoPagamento}
            selectedModeloNegocio={selectedModeloNegocio}
            entregavel={entregavel}
            midias={midias}
            onChangeEntregavel={onChangeEntregavel}
            onChangeMidias={onChangeMidias}
            selectedEntregaveis={selectedEntregaveis}
            selectedMidias={selectedMidias}
            data={data}
            validade={validade}
            showCadastraraMidia={showCadastraraMidia}
            contatoAgencia={contatoAgencia}
            emailAgencia={emailAgencia}
            telefoneAgencia={telefoneAgencia}
            listContatoAgencia={listContatoAgencia}
            contatoCliente={contatoCliente}
            emailCliente={emailCliente}
            telefoneCliente={telefoneCliente}
            listContatoCliente={listContatoCliente}
            descricao={descricao}
            filteredClients={filteredClients}
            filteredAgency={filteredAgency}
            changeFootNotes={changeFootNotes}
            footNotes={footNotes}
            selectedFootNote={selectedFootNote}
            changeCadastroDescricao={changeCadastroDescricao}
            descricoes={descricoes}
            selectedCadastro={selectedCadastro}
            changeType={changeType}
            editContact={editContact}
            saveContact={saveContact}
            selectedContact={selectedContact}
            showContactModal={showContactModal}
            showContatoModal={showContatoModal}
            type={type}
            showFormPessoa={showFormPessoa}
            editPessoa={editPessoa}
          />
          <OrderCalc
            selectedModeloNegocio={selectedModeloNegocio}
            totalOrder={totalItens}
            brandStars={brandStars}
            textColor={textColor}
            changeInput={changeInput}
            totalCalculado={totalCalculado}
            acrescimo={acrescimo}
            comissao={comissao}
            desconto={desconto}
            tipoAcrescimo={tipoAcrescimo}
            tipoComissao={tipoComissao}
            tipoDesconto={tipoDesconto}
            accountSelected={accountSelected}
          />
          <OrderItemDynamic
            textColor={textColor}
            brandStars={brandStars}
            borderColor={borderColor}
            itens={itens}
            showCategory={showCategory}
            nomeRef={nomeRef}
            saveItem={saveItem}
            changeItem={changeItem}
            removeItem={removeItem}
            showItemModal={showItemModal}
            reorder={reorder}
            drag={drag}
            isDragable={isDragable}
            onChangeTemplate={onChangeTemplate}
            templateList={templateList}
            totalOrder={total}
            condicaoPagamento={condicaoPagamento}
            addRowItem={addRowItem}
            deleteRow={deleteRow}
            editRow={editRow}
            itemList={itemList}
          />
          <OrderLetter
            carta={carta}
            changeCarta={changeCarta}
            cliente={selectedClient ?? accountSelected?.cliente}
            agencia={selectedAgency ?? accountSelected?.agencia}
            contatoAgencia={listContatoAgencia?.find((a) => a.id === contatoAgencia)?.nome ?? listContatoAgencia?.find((a) => a.id === accountSelected?.contatoAgencia)?.nome}
            numeroProposta={accountSelected?.id?.toString() ?? '00000000'}
            contatoCliente={listContatoCliente?.find((a) => a.id === contatoCliente)?.nome ?? listContatoCliente?.find((a) => a.id === accountSelected?.contatoCliente)?.nome}
            projeto={nome ?? accountSelected?.nome}
            showAgenciaInput={showAgenciaInput}
            totalOrder={selectedModeloNegocio === null ? total : totalCalculado}
            validade={validade ?? accountSelected?.validade}
            itens={itens ?? accountSelected.OrcamentoCategoria}
            descricao={descricao ?? accountSelected?.descricao}
            footNote={selectedFootNote?.descricao ?? accountSelected?.notaRodapeTexto}
            selectedEntregaveis={selectedEntregaveis}
            condicaoPagamento={selectedCondicaoPagamento ?? accountSelected?.condicaoPagamento}
            entregavel={entregavel}
          />
        </Accordion>
      </Box>
    </Box>
  );
};
export default FormOrder;
